import React from 'react'
import {
  imgFrame23373,
  imgFluentCertificate20Regular,
  imgGroup23643
} from './assets'

const CourseIncludes = () => {
  const courseFeatures = [
    {
      icon: "https://img.learntube.ai/public-assets/personalise/Pricing/Frame%2023373%20(4).webp",
      text: "4 Practical Projects"
    },
    {
      icon: "https://img.learntube.ai/public-assets/personalise/Pricing/fluent_certificate-20-regular%20(1).webp",
      text: "Certificate Of Completion"
    },
  ]

  return (
    <div className="content-stretch flex flex-col gap-[16px] items-start relative shrink-0 w-full">
      <p className="font-bold leading-none not-italic relative shrink-0 text-[#70aeff] text-[16px] w-full">
        What's Included
      </p>
      <div className="gap-x-[8px] gap-y-[8px] grid grid-cols-[repeat(2,minmax(0,1fr))] grid-rows-[repeat(2,fit-content(100%))] relative shrink-0 w-full">
        {courseFeatures.map((feature, index) => (
          <div key={index} className={`${index === 2 ? 'col-1 row-2' : index === 0 ? 'col-1 row-1' : 'col-2 row-1'} content-stretch flex gap-[12px] items-center justify-center justify-self-start relative self-start shrink-0`}>
            <div className="ml-0 mt-0 relative row-1 w-[20px] h-[20px] flex-shink-0">
              <img alt="" className="size-full" src={feature.icon} />
            </div>
            <div className="content-stretch flex flex-col items-center relative">
              <p className=" font-normal text-left leading-none not-italic relative text-[12px] text-[rgba(255,255,255,0.5)]">
                {feature.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CourseIncludes